(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;

    var items = bar.querySelectorAll('[data-announcement-item]');
    if (items.length < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var index = 0;

    setInterval(function () {
      items[index].classList.add('announcement__item--hidden');
      index = (index + 1) % items.length;
      items[index].classList.remove('announcement__item--hidden');
    }, 5000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cs]').forEach(function (root) {
      var range = root.querySelector('[data-cs-range]');
      if (!range) return;

      var timers = [];
      var introDone = false;

      function apply(value) {
        root.style.setProperty('--cs-pos', value);
      }

      function endIntro() {
        introDone = true;
        timers.forEach(clearTimeout);
        timers = [];
        root.classList.remove('cs--intro');
      }

      function introStep(value) {
        if (introDone) return;
        range.value = value;
        apply(value);
      }

      range.addEventListener('input', function () {
        if (!introDone) endIntro();
        apply(range.value);
      });
      range.addEventListener('pointerdown', endIntro);

      apply(range.value);

      /* Tanıtım hareketi: sürüklenebildiğini bir kez göster. Hareket azaltma
         tercihinde hiç çalışmaz (mağaza sahibi zorlamadıysa). */
      var forced = document.documentElement.hasAttribute('data-force-motion');
      var reduced = !forced && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || introDone) return;
            io.disconnect();
            root.classList.add('cs--intro');
            timers.push(setTimeout(function () { introStep(35); }, 260));
            timers.push(setTimeout(function () { introStep(65); }, 1000));
            timers.push(setTimeout(function () { introStep(50); }, 1740));
            timers.push(setTimeout(endIntro, 2500));
          });
        },
        { threshold: 0.4 }
      );

      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-cd-sticky]');
    if (!bar) return;

    var clone = null;
    var anchor = bar.getBoundingClientRect().top + window.scrollY + bar.offsetHeight;

    function onScroll() {
      var past = window.scrollY > anchor + 120;
      if (past && !clone) {
        clone = bar.cloneNode(true);
        clone.classList.add('cd-stuck');
        clone.removeAttribute('data-cd-sticky');
        document.body.appendChild(clone);
        requestAnimationFrame(function () {
          clone.classList.add('is-shown');
          /* Yapışkan menü çubuğun altına insin, üst üste binmesin. */
          document.documentElement.style.setProperty('--cd-stuck-h', clone.offsetHeight + 'px');
        });
        startClock(clone);
      } else if (!past && clone) {
        clone.classList.remove('is-shown');
        document.documentElement.style.setProperty('--cd-stuck-h', '0px');
        var dead = clone; clone = null;
        setTimeout(function () { dead.remove(); }, 500);
      }
    }

    /* Klonun sayacı da işlesin — orijinalin JS'i yalnız orijinali günceller. */
    function startClock(node) {
      /* HATA DÜZELTMESİ: burada '[data-cd-unit], b' aranıyordu; bu işaretlemede
         öyle bir öğe YOK (değerler .countdown__value içinde). İkisi de boş
         dizi dönüyor, döngü hiç çalışmıyor ve yapışkan kopyanın saati
         klonlandığı saniyede donmuş kalıyordu. */
      var src = bar.querySelectorAll('.countdown__value');
      var dst = node.querySelectorAll('.countdown__value');
      setInterval(function () {
        if (!node.isConnected) return;
        for (var i = 0; i < src.length && i < dst.length; i++) {
          if (dst[i].textContent !== src[i].textContent) dst[i].textContent = src[i].textContent;
        }
      }, 1000);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  (function () {
    'use strict';

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    /* Bitiş anını çöz.

       'date' modunda bu, ayarlardaki sabit tarihtir — herkes aynı sayıyı görür.

       'rolling' modunda ziyaretçi başına bir bitiş anı kurulur ve tarayıcıya
       yazılır; böylece sayfalar arasında gezerken sayaç sıfırlanmaz. Kayıtlı
       an geçmişse yenisi kurulur (yoksa geri dönen ziyaretçi kalıcı olarak
       "kampanya bitti" görürdü).

       localStorage engelliyse (gizli sekme, katı gizlilik ayarı) sessizce
       oturumluk davranışa düşer: sayaç o sayfada tam süreden başlar. */
    function resolveEnd(root) {
      if (root.getAttribute('data-mode') !== 'rolling') {
        return new Date(root.getAttribute('data-end')).getTime();
      }

      var hours = parseFloat(root.getAttribute('data-hours'));
      if (!(hours > 0)) hours = 5;

      var span = hours * 3600 * 1000;
      var key = root.getAttribute('data-storage-key') || 'vorelisse-cd';
      var now = Date.now();
      var stored = null;

      try {
        stored = parseInt(window.localStorage.getItem(key), 10);
      } catch (e) {
        stored = null;
      }

      /* Kayıt yoksa, bozuksa, geçmişse ya da süreden UZUNSA (ayar küçültülmüş
         olabilir) yeniden kur. */
      if (!stored || isNaN(stored) || stored <= now || stored - now > span) {
        stored = now + span;
        try {
          window.localStorage.setItem(key, String(stored));
        } catch (e) {
          /* yazamıyoruz; sayaç yine çalışır, yalnız sayfa değişince sıfırlanır */
        }
      }

      return stored;
    }

    function init(root) {
      if (root.dataset.countdownReady === 'true') return;
      root.dataset.countdownReady = 'true';

      var timer = root.querySelector('[data-countdown-timer]');
      var expired = root.querySelector('[data-countdown-expired]');
      var message = root.querySelector('[data-countdown-message]');
      var dayUnit = root.querySelector('[data-countdown-day-unit]');
      var end = resolveEnd(root);
      var cells = {
        d: root.querySelector('[data-countdown-days]'),
        h: root.querySelector('[data-countdown-hours]'),
        m: root.querySelector('[data-countdown-minutes]'),
        s: root.querySelector('[data-countdown-seconds]')
      };
      var last = { d: '', h: '', m: '', s: '' };
      var interval = null;

      if (isNaN(end) || !timer || !cells.d || !cells.h || !cells.m || !cells.s) return;

      function finish() {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
        timer.hidden = true;
        if (message) message.hidden = true;
        if (expired) {
          expired.hidden = false;
          requestAnimationFrame(function () {
            expired.classList.add('is-visible');
          });
        }
      }

      function render() {
        var diff = end - Date.now();
        if (diff <= 0) {
          finish();
          return;
        }
        var t = Math.floor(diff / 1000);
        var vals = {
          d: String(Math.floor(t / 86400)),
          h: pad(Math.floor((t % 86400) / 3600)),
          m: pad(Math.floor((t % 3600) / 60)),
          s: pad(t % 60)
        };
        for (var k in vals) {
          if (vals[k] !== last[k]) {
            last[k] = vals[k];
            cells[k].textContent = vals[k];
          }
        }

        /* Gün 0'a düşünce birimi gizle (Liquid ilk basımda aynısını yapıyor). */
        if (dayUnit) dayUnit.hidden = vals.d === '0';
      }

      render();
      interval = setInterval(function () {
        if (document.hidden) return;
        render();
      }, 1000);

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && interval) render();
      });
    }

    var roots = document.querySelectorAll('[data-countdown]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-countdown]');
      if (root) init(root);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Neon yazı: imleç yatayda gezindikçe yazı kendi ekseninde hafif döner.
     Yalnız bant ekrandayken dinlenir; parmakla dokunmada hiç çalışmaz
     (dokunmada "imleç konumu" diye bir şey yok, dönme rastgele görünürdü). */
  (function () {
    var band = document.querySelector('[data-neon-parallax]');
    if (!band) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;

    var word = band.querySelector('.neon__word');
    var mirror = band.querySelector('.neon__reflection');
    if (!word) return;

    var live = false;
    var pending = false;
    var target = 0;

    function apply() {
      pending = false;
      word.style.setProperty('--neon-spin', target.toFixed(2) + 'deg');
      if (mirror) mirror.style.setProperty('--neon-spin', target.toFixed(2) + 'deg');
    }

    function onMove(event) {
      if (!live) return;
      var rect = band.getBoundingClientRect();
      /* -1 .. 1 */
      var ratio = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      target = Math.max(-1, Math.min(1, ratio)) * 9;
      if (!pending) {
        pending = true;
        requestAnimationFrame(apply);
      }
    }

    /* Bant görünür değilken fare olayı dinlemenin anlamı yok. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        live = entries[0].isIntersecting;
        if (!live) {
          target = 0;
          apply();
        }
      }, { threshold: 0 }).observe(band);
    } else {
      live = true;
    }

    window.addEventListener('mousemove', onMove, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-popup"]) return;
  try {
    
  (function () {
    var pop = document.querySelector('[data-gift-popup]');
    if (!pop) return;

    var panel = pop.querySelector('.giftpop__panel');
    var acan = null;

    function odaklanabilir() {
      return panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }

    function ac(tetikleyen) {
      if (!pop.hidden) return;
      acan = tetikleyen || null;
      pop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
        var ilk = odaklanabilir()[0];
        if (ilk) ilk.focus();
      });
    }

    function kapat() {
      if (pop.hidden) return;
      pop.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      /* Geçiş hiç tetiklenmezse (hareket azaltma) pencere açık kalmasın. */
      setTimeout(function () {
        pop.hidden = true;
        if (acan && acan.focus) acan.focus();
        acan = null;
      }, 300);
    }

    document.addEventListener('click', function (event) {
      var tetik = event.target.closest('[data-gift-open]');
      if (tetik) {
        event.preventDefault();
        ac(tetik);
        return;
      }
      if (event.target.closest('[data-gift-close]')) {
        event.preventDefault();
        kapat();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (pop.hidden) return;
      if (event.key === 'Escape') { kapat(); return; }
      if (event.key !== 'Tab') return;

      /* Odak tuzağı: sekme tuşu panelin dışına çıkmasın. */
      var list = odaklanabilir();
      if (!list.length) return;
      var ilk = list[0], son = list[list.length - 1];
      if (event.shiftKey && document.activeElement === ilk) {
        event.preventDefault(); son.focus();
      } else if (!event.shiftKey && document.activeElement === son) {
        event.preventDefault(); ilk.focus();
      }
    });

    /* Kendiliğinden açılma — ziyaretçi başına bir kez. */
    if (pop.dataset.auto === '1') {
      var anahtar = pop.dataset.key || 'vorelisse-gift';
      var gosterildi = false;
      try { gosterildi = window.localStorage.getItem(anahtar) === '1'; } catch (e) {}
      if (!gosterildi) {
        setTimeout(function () {
          if (document.hidden) return;
          ac(null);
          try { window.localStorage.setItem(anahtar, '1'); } catch (e) {}
        }, (parseInt(pop.dataset.delay, 10) || 8) * 1000);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var toggle = header.querySelector('[data-menu-toggle]');
    var nav = header.querySelector('[data-mobile-nav]');

    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        nav.hidden = isOpen;
      });
    }

    // Masaüstü açılır menüler: dışarı tıklayınca ve Esc ile kapansın
    var dropdowns = header.querySelectorAll('.header__dropdown');

    document.addEventListener('click', function (event) {
      dropdowns.forEach(function (details) {
        if (!details.open) return;
        if (!details.contains(event.target)) details.open = false;
      });
    });

    // Kaydırıldığında hap biraz daha katılaşır — konum değişmez, sadece yüzey.
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      dropdowns.forEach(function (details) {
        details.open = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* Sepet sayfası — sayfayı yenilemeden adet/kaldırma ve not kaydı.

     Bağlantılar (`href`) yerinde duruyor: JS yoksa tarayıcı onları normal
     şekilde izler ve sepet yine çalışır. JS varsa tıklama yakalanır,
     Shopify'ın /cart/change.js ucu çağrılır ve sayfa Section Rendering API
     ile tazelenir — sepet HTML'inin tek kaynağı yine bu Liquid dosyası,
     JS'te ikinci bir şablon yok. */
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var section = page.closest('.shopify-section') || page.parentElement;
    var sectionId = 'main-cart';

    /* Bölüm kimliğini sarmalayıcının id'sinden çöz: "shopify-section-<id>" */
    if (section && section.id && section.id.indexOf('shopify-section-') === 0) {
      sectionId = section.id.replace('shopify-section-', '');
    }

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* Sunucudan taze sepet sayfası al ve yerine koy.
       DİKKAT: 'Accept: application/json' GÖNDERİLMEZ — o başlıkla Shopify
       `sections` parametresini yok sayıp sepet JSON'u döndürüyor. */
    function refresh() {
      return fetch(root() + '?sections=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html || !section) return;

          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-page]');
          var current = section.querySelector('[data-cart-page]');
          if (fresh && current) current.replaceWith(fresh);

          if (window.theme && window.theme.refreshCartCount) window.theme.refreshCartCount();
        })
        .catch(function () {
          /* Tazeleme kaçtıysa sunucudaki sepet yine doğru: sayfayı yenile. */
          window.location.reload();
        });
    }

    function change(body) {
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) { return res.json(); });
    }

    page.addEventListener('click', function (event) {
      var control = event.target.closest('[data-line-change]');
      if (!control) return;

      event.preventDefault();

      var row = control.closest('[data-cart-item]');
      if (!row || row.classList.contains('is-busy')) return;

      row.classList.add('is-busy');

      change({ id: row.dataset.key, quantity: Number(control.dataset.lineChange) })
        .then(refresh)
        .catch(function () { window.location.reload(); });
    });

    /* Sipariş notu: alandan çıkınca kaydet, ayrı düğmeye gerek kalmasın. */
    var note = page.querySelector('textarea[name="note"]');
    var saveButton = page.querySelector('[data-note-save]');
    var hint = page.querySelector('[data-note-hint]');

    if (note) {
      if (saveButton) saveButton.hidden = true;
      if (hint) hint.hidden = false;

      var savedValue = note.value;

      note.addEventListener('blur', function () {
        if (note.value === savedValue) return;
        savedValue = note.value;

        fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {
          /* Kaydedilemediyse düğmeyi geri getir; kullanıcı elle gönderebilsin. */
          if (saveButton) saveButton.hidden = false;
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var login = document.getElementById('LoginPanel');
    var recover = document.getElementById('RecoverPassword');
    if (!login || !recover) return;

    function show(target) {
      login.hidden = target !== 'login';
      recover.hidden = target !== 'recover';
    }

    document.querySelectorAll('[data-show-recover]').forEach(function (el) {
      el.addEventListener('click', function () {
        show('recover');
      });
    });

    document.querySelectorAll('[data-show-login]').forEach(function (el) {
      el.addEventListener('click', function () {
        show('login');
      });
    });

    if (window.location.hash === '#recover') show('recover');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-product-section]');

    sections.forEach(function (root) {
      var dataEl = root.querySelector('[data-variant-data]');
      if (!dataEl) return;

      var variants = JSON.parse(dataEl.textContent);
      var idInput = root.querySelector('[data-variant-id]');
      var priceTarget = root.querySelector('[data-price-target]');
      var addButton = root.querySelector('[data-add-button]');
      var addText = root.querySelector('[data-add-text]');
      var qtyInput = root.querySelector('[data-quantity-input]');
      var personalizations = root.querySelectorAll('[data-personalization]');
      /* Kademe/paket paneli hâlâ TEK bloğun ayarlarını okuyor (satır içi
         alanların etiketi ve yer tutucusu oradan gelir); ilk blok o rolü
         üstlenir. Görünürlüğü ise aşağıda hepsi için ayrı ayrı yönetilir. */
      var personalization = personalizations[0] || null;
      var form = root.querySelector('[data-product-form]');
      var buybarPrice = document.querySelector('[data-buybar-price]');
      var strings = (window.theme && window.theme.strings) || {};

      function formatMoney(cents) {
        if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(cents);
        return (cents / 100).toFixed(2);
      }

      /* --- Varyant seçimi ------------------------------------------------ */

      function selectedOptions() {
        var picked = [];
        root.querySelectorAll('[data-option-position]').forEach(function (input) {
          if (input.checked) picked[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return picked;
      }

      function matchVariant(picked) {
        return variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === picked[index];
          });
        });
      }

      function renderPrice(variant) {
        if (!priceTarget) return;

        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var html = '<div class="price price--large' + (onSale ? ' price--on-sale' : '') + '">';
        html += '<span class="price__current">' + formatMoney(variant.price) + '</span>';

        if (onSale) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          html += '<span class="badge badge--sale price__badge">%' + pct + '</span>';
        }

        html += '</div>';
        priceTarget.innerHTML = html;
      }

      /* Fiyata bağlı diğer alanlar. renderPrice'ın İÇİNDE değiller: o fonksiyon
         fiyat bloğu yoksa (bu üründe fiyat, adet kademelerinde gösteriliyor)
         ilk satırda dönüyor ve buradakiler hiç çalışmıyordu. */
      function renderPriceDependents(variant) {
        if (buybarPrice) buybarPrice.textContent = formatMoney(variant.price);
        renderInstallments(variant);
      }

      function togglePersonalization(variant) {
        Array.prototype.forEach.call(personalizations, function (node) {
          /* Metin alanı tektir; seçim alanı bir radyo GRUBUDUR — ikisi de
             aynı kancayı kullandığı için hepsini birden gez. */
          var inputs = node.querySelectorAll('[data-personalization-input]');
          var isChoice = node.querySelector('[data-choice-input]') !== null;

          var show;
          if (node.dataset.always === 'true') {
            show = true;
          } else {
            var trigger = node.dataset.trigger || '';
            show = trigger !== '' && variant.title.toLowerCase().indexOf(trigger.toLowerCase()) !== -1;
          }

          node.hidden = !show;
          Array.prototype.forEach.call(inputs, function (input) {
            input.disabled = !show;
            /* Radyo grubunda "required" gerekmez: biri zaten seçili. */
            input.required = show && !isChoice;
            if (!show && !isChoice) input.value = '';
          });
        });
      }

      function updateSelectedLabels(variant) {
        variant.options.forEach(function (value, index) {
          var label = root.querySelector('[data-selected-value="' + (index + 1) + '"]');
          if (label) label.textContent = value;
        });
      }

      /* Kademe fiyatları: sabit TL indirimi (birim × adet − indirim). */
      function updateTierPrices(variant) {
        var listUnit = variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price
          : variant.price;

        root.querySelectorAll('[data-tier-qty]').forEach(function (input) {
          var qty = Number(input.dataset.tierQty);
          var discount = Number(input.dataset.tierDiscount) || 0;
          var final = variant.price * qty - discount * 100;
          var list = listUnit * qty;

          var priceEl = root.querySelector('[data-tier-price="' + qty + '"]');
          var wasEl = root.querySelector('[data-tier-was="' + qty + '"]');

          if (priceEl) priceEl.textContent = formatMoney(final);
          if (wasEl) wasEl.textContent = formatMoney(list);
        });
      }

      /* Seçili varyantı UYGULA: fiyat, galeri, taksit, kademe fiyatları,
         satın alma düğmesi ve adres çubuğu.

         `onVariantChange`den ayrıldı çünkü artık varyantı seçen İKİ yol var:
         klasik varyant seçici (blok açıksa) ve adet panelindeki 1. ürün
         kartları. İkisi de aynı fonksiyonu çağırıyor, davranış tek yerde. */
      function applyVariant(variant) {
        if (!variant) return;

        if (idInput) idInput.value = variant.id;
        renderPrice(variant);
        renderPriceDependents(variant);
        updateSelectedLabels(variant);
        togglePersonalization(variant);
        updateTierPrices(variant);

        if (addButton) {
          addButton.disabled = !variant.available;
          if (addText) {
            addText.textContent = variant.available
              ? strings.addToCart || addText.textContent
              : strings.soldOut || addText.textContent;
          }
        }

        if (variant.featured_media) showMedia(variant.featured_media.id);

        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      /* Klasik varyant seçici (blok açıksa). Kapalıysa hiç çalışmaz. */
      function onVariantChange() {
        applyVariant(matchVariant(selectedOptions()));
      }

      /* Kartın üstüne gelince galeri o seçeneğin görselini gösterir; fare
         çıkınca seçili varyantın görseline döner. Yalnız gerçek imleçli
         cihazlarda: dokunmatikte "üstüne gelme" tıklamaya dönüşür ve galeri
         seçim yapılmadan zıplar. */
      var pickerEl = root.querySelector('[data-variant-picker]');
      if (pickerEl && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        pickerEl.addEventListener('mouseover', function (event) {
          var card = event.target.closest('[data-preview-media]');
          if (!card || !pickerEl.contains(card)) return;
          showMedia(card.dataset.previewMedia);
        });

        pickerEl.addEventListener('mouseleave', function () {
          var current = matchVariant(selectedOptions());
          if (current && current.featured_media) showMedia(current.featured_media.id);
        });
      }

      root.querySelectorAll('[data-option-position]').forEach(function (input) {
        input.addEventListener('change', onVariantChange);
      });

      /* Seçim alanının başlığında seçili değer yazsın. */
      root.querySelectorAll('[data-choice-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          var wrap = input.closest('[data-personalization]');
          var label = wrap && wrap.querySelector('[data-choice-selected]');
          if (label) label.textContent = input.value;
        });
      });

      /* --- Galeri --------------------------------------------------------- */

      function showMedia(mediaId) {
        root.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
          slide.classList.toggle('is-active', slide.dataset.mediaId === String(mediaId));
        });
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
          var active = thumb.dataset.mediaId === String(mediaId);
          thumb.classList.toggle('is-active', active);
          if (active) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showMedia(thumb.dataset.mediaId);
        });
      });

      /* --- Adet kademeleri + ürün başına varyant seçimi --------------------

         Üç şeyi aynı anda tutarlı tutar:
           1. gizli `quantity` alanı            (JS'siz gönderim + yedek yol)
           2. gizli `id` alanı                  (aynı)
           3. `[data-cart-payload]` JSON gövdesi (asıl yol: çok satırlı ekleme)

         Neden hem 1-2 hem 3: hazır ödeme düğmeleri (Shop Pay / "Hemen satın
         alın") formu Shopify'ın kendi betiği üzerinden gönderir, JSON
         yükümüzü bilmez. Bütün satırlar AYNI varyanttaysa id+quantity zaten
         doğru sonucu verir; varyantlar FARKLIYSA o düğme gizlenir (aşağıda) —
         çünkü müşterinin seçtiğinden başka bir şey satın alması,
         gizlemekten çok daha kötüdür. */

      var bundle = root.querySelector('[data-bundle]');
      var payloadInput = root.querySelector('[data-cart-payload]');
      var dynamicCheckout = root.querySelector('.shopify-payment-button');
      var tierInputs = root.querySelectorAll('[data-tier-qty]');

      /* Hazır ödeme düğmesi (Shop Pay / Apple Pay) formu Shopify'ın kendi
         betiğiyle gönderiyor; tarayıcının "zorunlu alan" denetimi her zaman
         devreye girmiyor. Hediye anahtarlığının ismi boşken sipariş geçerse
         ne yazacağımızı bilemeyiz — bu yüzden burada elle denetleniyor. */
      if (dynamicCheckout && form) {
        dynamicCheckout.addEventListener('click', function (event) {
          if (form.checkValidity()) return;
          event.preventDefault();
          event.stopPropagation();
          form.reportValidity();
        }, true);
      }

      function currentQty() {
        var checked = root.querySelector('[data-tier-qty]:checked');
        if (checked) return Number(checked.dataset.tierQty) || 1;
        return Math.max(1, Number(qtyInput && qtyInput.value) || 1);
      }

      /* Kişiselleştirme kuralı tek yerde tanımlı: ayrı blok. Kademe bloğu onu
         DOM'dan okur, böylece iki yerde iki farklı tetikleyici olmaz. */
      function personalizationTrigger() {
        if (!personalization) return '';
        return (personalization.dataset.trigger || '').toLowerCase();
      }

      function variantById(id) {
        return variants.find(function (v) { return String(v.id) === String(id); });
      }

      function needsPersonalization(variant) {
        var trigger = personalizationTrigger();
        if (!trigger || !variant) return false;
        return variant.title.toLowerCase().indexOf(trigger) !== -1;
      }

      /* Formdaki `properties[...]` alanları — hediye notu, teslim tarihi.
         Bunlar sipariş geneline aittir, her satıra aynen kopyalanır. */
      function sharedProperties() {
        var props = {};
        root.querySelectorAll('[name^="properties["]').forEach(function (field) {
          if (field.disabled) return;
          /* Kişiselleştirme alanı paylaşılan değil: satıra özeldir. */
          if (field.hasAttribute('data-personalization-input')) return;
          var match = field.name.match(/^properties\[(.+)\]$/);
          if (!match) return;
          var value = (field.value || '').trim();
          if (value) props[match[1]] = value;
        });
        return props;
      }

      /* Bir satırın seçili varyantı. */
      function rowVariant(row) {
        var picked = row.querySelector('[data-bundle-variant]:checked');
        return picked ? variantById(picked.value) : null;
      }

      /* Bir satırın seçimini oku. */
      function readRow(row) {
        var variant = rowVariant(row);
        if (!variant) return null;

        var input = row.querySelector('[data-bundle-personal-input]');
        var text = input && !input.disabled ? (input.value || '').trim() : '';

        return { variant: variant, personalization: text };
      }

      function visibleRows() {
        if (!bundle) return [];
        return Array.prototype.filter.call(
          bundle.querySelectorAll('[data-bundle-row]'),
          function (row) { return !row.hidden; }
        );
      }

      /* Satırları seçili adede göre aç/kapat, görselleri ve kişiselleştirme
         alanlarını tazele. */
      function syncBundle() {
        var qty = currentQty();

        if (qtyInput) qtyInput.value = qty;

        if (!bundle) {
          if (payloadInput) payloadInput.value = '';
          return;
        }

        /* Panel HER adette görünür — varyasyon artık yalnız burada seçiliyor,
           1 adet alanın da seçim yapabilmesi gerekiyor. `multi` yalnız
           kişiselleştirme bloğunun yerini belirlemek için kullanılıyor. */
        var multi = qty > 1;
        bundle.hidden = false;

        var propName = personalization
          ? (personalization.dataset.propertyName || '')
          : '';
        var placeholder = personalization
          ? (personalization.dataset.placeholder || '')
          : '';

        bundle.querySelectorAll('[data-bundle-row]').forEach(function (row) {
          var index = Number(row.dataset.bundleRow);
          var active = index <= qty;

          row.hidden = !active;

          /* Kapalı satırların alanları forma da girmemeli, sekmeyle de
             gezilmemeli. Tükenmiş varyant her hâlükârda kapalı kalır. */
          row.querySelectorAll('[data-bundle-variant]').forEach(function (input) {
            input.disabled = !active || input.hasAttribute('data-unavailable');
          });

          var variant = rowVariant(row);

          /* Satır başlığında seçilenin adı — panel kapanmadan görünür olsun. */
          var chosen = row.querySelector('[data-bundle-chosen]');
          if (chosen) chosen.textContent = variant ? variant.title : '';

          /* Satıra özel kişiselleştirme alanı. */
          var wrap = row.querySelector('[data-bundle-personal]');
          var input = row.querySelector('[data-bundle-personal-input]');
          var wants = active && needsPersonalization(variant);

          if (wrap) wrap.hidden = !wants;
          if (input) {
            input.disabled = !wants;
            input.required = wants;
            input.placeholder = placeholder;
            input.setAttribute('aria-label', index + '. ürün — ' + propName);
            if (!wants) input.value = '';
          }
        });

        /* Çoklu moddayken tek kişiselleştirme bloğu kafa karıştırır: her
           ürünün kendi alanı satırının içinde. Bloğu kapat ve alanını forma
           girmeyecek hâle getir. */
        if (personalization) {
          var soloInput = personalization.querySelector('[data-personalization-input]');
          if (multi) {
            personalization.hidden = true;
            if (soloInput) {
              soloInput.disabled = true;
              soloInput.required = false;
            }
          }
          /* multi false ise görünürlüğü togglePersonalization yönetir. */
        }

        updatePayload();
      }

      /* Sepet gövdesini kur. Aynı varyant + aynı kişiselleştirme olan satırlar
         tek satırda birleşir (Shopify de zaten birleştirir; burada birleştirmek
         gönderimi ve sepet görüntüsünü öngörülebilir kılar). */
      function updatePayload() {
        if (!payloadInput) return;

        var rows = visibleRows();

        /* Panel kapalıysa (tek ürün) klasik id+quantity yolu kullanılır. */
        if (!rows.length) {
          payloadInput.value = '';
          if (dynamicCheckout) dynamicCheckout.hidden = false;
          return;
        }

        var shared = sharedProperties();
        var propName = personalization
          ? (personalization.dataset.propertyName || 'Kişiselleştirme')
          : 'Kişiselleştirme';

        var lines = [];
        var index = {};
        var firstVariantId = null;
        var mixed = false;

        rows.forEach(function (row) {
          var picked = readRow(row);
          if (!picked) return;

          if (firstVariantId === null) {
            firstVariantId = picked.variant.id;
          } else if (picked.variant.id !== firstVariantId) {
            mixed = true;
          }

          var properties = {};
          Object.keys(shared).forEach(function (key) { properties[key] = shared[key]; });
          if (picked.personalization) properties[propName] = picked.personalization;

          var key = picked.variant.id + '|' + JSON.stringify(properties);

          if (index[key]) {
            index[key].quantity += 1;
          } else {
            var line = { id: picked.variant.id, quantity: 1 };
            if (Object.keys(properties).length) line.properties = properties;
            index[key] = line;
            lines.push(line);
          }
        });

        payloadInput.value = lines.length ? JSON.stringify({ items: lines }) : '';

        /* Yedek yol (hazır ödeme düğmesi / JS'siz gönderim) yalnız tüm
           satırlar aynı varyantken doğru sonuç verir. */
        if (idInput && firstVariantId !== null && !mixed) {
          idInput.value = firstVariantId;
        }

        if (dynamicCheckout) {
          dynamicCheckout.hidden = mixed;
          var mixedNote = root.querySelector('[data-mixed-note]');
          if (mixedNote) mixedNote.hidden = !mixed;
        }
      }

      if (bundle) {
        bundle.addEventListener('change', function (event) {
          var radio = event.target.closest('[data-bundle-variant]');
          if (radio) {
            /* 1. ürün, sayfanın "seçili varyantı"dır: fiyat, galeri, taksit ve
               adres çubuğu onu izler. Diğer satırlar yalnız sepete gider. */
            if (Number(radio.dataset.bundleVariant) === 1) {
              var variant = variantById(radio.value);
              if (variant) selectMainVariant(variant);
            }
            syncBundle();
            return;
          }

          if (event.target.closest('[data-bundle-personal-input]')) updatePayload();
        });

        bundle.addEventListener('input', function (event) {
          if (event.target.closest('[data-bundle-personal-input]')) updatePayload();
        });
      }

      /* İsim alanlarına yalnız harf girilir: emoji, rakam ve noktalama
         gravür/baskıda basılamıyor. Yakalama evresinde temizlenir ki
         sepet gövdesini kuran dinleyiciler temiz değeri görsün. */
      root.addEventListener('input', function (event) {
        var field = event.target.closest('[data-letters-only]');
        if (!field) return;
        var clean = field.value.replace(/[^A-Za-zÇĞİÖŞÜçğıöşü ]/g, '');
        if (clean === field.value) return;
        var pos = field.selectionStart - (field.value.length - clean.length);
        field.value = clean;
        try { field.setSelectionRange(pos, pos); } catch (err) {}
      }, true);

      /* Hediye notu / teslim tarihi değişince de gövde tazelenmeli. */
      root.querySelectorAll('[name^="properties["]').forEach(function (field) {
        field.addEventListener('input', updatePayload);
        field.addEventListener('change', updatePayload);
      });

      tierInputs.forEach(function (input) {
        input.addEventListener('change', syncBundle);
      });

      /* Üstteki seçiciyi programla değiştir: ilgili radyoyu işaretle ve
         normal varyant değişimi akışını çalıştır (fiyat, galeri, URL…). */
      function selectMainVariant(variant) {
        /* Klasik varyant seçici blok AÇIKSA onu da eşitle (iki yer aynı şeyi
           göstersin). Kapalıysa doğrudan uygula. */
        var hasPicker = !!root.querySelector('[data-option-position]');
        if (hasPicker) {
          variant.options.forEach(function (value, i) {
            root.querySelectorAll('[data-option-position="' + (i + 1) + '"]').forEach(function (input) {
              input.checked = input.value === value;
            });
          });
        }
        applyVariant(variant);
      }

      /* Üstten varyant değişince 1. satır onu takip eder. */
      function syncFirstRowFromMain() {
        if (!bundle || !idInput) return;
        bundle.querySelectorAll('[data-bundle-variant="1"]').forEach(function (input) {
          input.checked = input.value === idInput.value;
        });
        syncBundle();
      }

      root.querySelectorAll('[data-option-position]').forEach(function (input) {
        input.addEventListener('change', syncFirstRowFromMain);
      });

      /* --- Adet artır / azalt --------------------------------------------- */

      var minus = root.querySelector('[data-quantity-minus]');
      var plus = root.querySelector('[data-quantity-plus]');

      if (minus && plus && qtyInput) {
        minus.addEventListener('click', function () {
          qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
        });
        plus.addEventListener('click', function () {
          qtyInput.value = Number(qtyInput.value) + 1;
        });
      }

      /* --- Ürün içi geri sayım -------------------------------------------- */

      var cd = root.querySelector('[data-pdp-countdown]');
      if (cd) {
        /* Bitiş anı: 'date' modda sabit tarih, 'rolling' modda ziyaretçiye
           özel süre. Rolling'de bitiş anı localStorage'a yazılır; üstteki
           geri sayım çubuğu aynı anahtarı kullandığı için iki sayaç aynı
           yerden devam eder. Kayıt yoksa/bozuksa/geçmişse ya da ayarlanan
           süreden uzunsa yeniden kurulur. */
        var resolveEnd = function () {
          if (cd.dataset.mode !== 'rolling') return Date.parse(cd.dataset.end || '');

          var hours = parseFloat(cd.dataset.hours);
          if (!(hours > 0)) hours = 5;

          var span = hours * 3600 * 1000;
          var key = cd.dataset.storageKey || 'vorelisse-cd';
          var now = Date.now();
          var stored = null;

          try { stored = parseInt(window.localStorage.getItem(key), 10); } catch (e) { stored = null; }

          if (!stored || isNaN(stored) || stored <= now || stored - now > span) {
            stored = now + span;
            try { window.localStorage.setItem(key, String(stored)); } catch (e) {}
          }

          return stored;
        };

        var end = resolveEnd();
        var clock = cd.querySelector('[data-pdp-clock]');
        var done = cd.querySelector('[data-pdp-done]');
        var dayUnit = cd.querySelector('[data-cd-day-unit]');
        var daySep = cd.querySelector('[data-cd-day-sep]');
        var f = {
          d: cd.querySelector('[data-cd-d]'), h: cd.querySelector('[data-cd-h]'),
          m: cd.querySelector('[data-cd-m]'), s: cd.querySelector('[data-cd-s]')
        };
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };

        var tick = function () {
          if (isNaN(end)) return;
          var left = end - Date.now();
          if (left <= 0) {
            clock.hidden = true;
            if (done) done.hidden = false;
            return;
          }
          if (document.hidden) return;
          var sec = Math.floor(left / 1000);
          var days = Math.floor(sec / 86400);
          /* "00 gün" yazmak sayacı uzatmaktan başka işe yaramıyor; üstteki
             çubukta da aynı kural var. */
          if (dayUnit) dayUnit.hidden = days < 1;
          if (daySep) daySep.hidden = days < 1;
          f.d.textContent = pad(days);
          f.h.textContent = pad(Math.floor(sec / 3600) % 24);
          f.m.textContent = pad(Math.floor(sec / 60) % 60);
          f.s.textContent = pad(sec % 60);
        };
        tick();
        setInterval(tick, 1000);
      }


      /* --- Mobil yapışkan satın alma çubuğu -------------------------------
         Yalnız asıl satın alma düğmesi ekran DIŞINDA ve YUKARIDA kaldığında
         görünür: kullanıcı ürünü görmeden çubuk çıkmasın, yukarı dönünce de
         yolda durmasın. Kendi formu yok — ana formu gönderir. */

      var buybar = document.querySelector('[data-buybar]');

      if (buybar && addButton && form && 'IntersectionObserver' in window) {
        var buybarShown = false;

        var setBuybar = function (show) {
          if (show === buybarShown) return;
          buybarShown = show;

          if (show) {
            buybar.hidden = false;
            buybar.setAttribute('aria-hidden', 'false');
            requestAnimationFrame(function () {
              buybar.classList.add('is-visible');
            });
          } else {
            buybar.classList.remove('is-visible');
            buybar.setAttribute('aria-hidden', 'true');
            setTimeout(function () {
              if (!buybarShown) buybar.hidden = true;
            }, 480);
          }
        };

        new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            var scrolledPast = entry.boundingClientRect.top < 0;
            setBuybar(!entry.isIntersecting && scrolledPast);
          },
          { threshold: 0 }
        ).observe(addButton);

        var buybarAdd = buybar.querySelector('[data-buybar-add]');
        if (buybarAdd) {
          buybarAdd.addEventListener('click', function () {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
          });
        }
      }


      /* --- Taksit tutarları ------------------------------------------------
         Varyant değişince tutarlar yeniden bölünür. Kuruş artığı ilk takside
         eklenmez — tablo bilgi amaçlı, banka kendi yuvarlamasını yapar. */

      function renderInstallments(variant) {
        root.querySelectorAll('[data-installment]').forEach(function (el) {
          var n = parseInt(el.getAttribute('data-installment'), 10);
          if (!n) return;
          el.textContent = formatMoney(Math.round(variant.price / n));
        });
      }

      /* --- Teslim tarihi alt sınırı ---------------------------------------
         Liquid'de "bugün" yok; alt sınır burada kurulur. JS kapalıysa alan
         yine çalışır, yalnız geçmiş bir tarih seçilebilir. */

      (function () {
        var dateInput = root.querySelector('[data-delivery-date]');
        if (!dateInput) return;

        var lead = parseInt(dateInput.getAttribute('data-lead-days'), 10) || 0;
        var min = new Date();
        min.setDate(min.getDate() + lead);

        var pad2 = function (n) { return n < 10 ? '0' + n : String(n); };
        dateInput.min =
          min.getFullYear() + '-' + pad2(min.getMonth() + 1) + '-' + pad2(min.getDate());
      })();

      /* --- İlk yükleme ---------------------------------------------------- */
      /* Fiyatları burada YENİDEN hesaplamıyoruz: Liquid onları zaten doğru
         para biçiminde bastı. */

      /* Fiyatlar ve taksitler Liquid'de zaten doğru para biçiminde basıldı;
         burada YENİDEN hesaplanmaz.

         Hesaplansaydı bozulurdu: bu bölüm betiği theme.js'ten ÖNCE çalışıyor,
         yani window.theme.formatMoney henüz tanımlı değil ve yerel yedek
         biçimlendirici devreye giriyor — para birimi eki ("TL") düşüyordu.
         Varyant değiştiğinde theme.js çoktan yüklenmiş olur, sorun yok. */
      var initial = matchVariant(selectedOptions());
      if (initial) togglePersonalization(initial);

      /* Kademe panelini ilk durumla kur: şablonda `default_tier` 2 olduğu için
         sayfa açılır açılmaz 2 satır görünür ve gövde hazır olur. */
      syncBundle();

      /* Gönderim anında son bir tazeleme. Değişiklikler zaten dinleniyor;
         bu, gözden kaçan bir alan (tarayıcı otomatik doldurma, eklenti)
         yüzünden bayat gövde gönderilmesini engeller. */
      if (form) {
        form.addEventListener('submit', function (event) {
          if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;
          updatePayload();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-tracking-form]');
    if (!form) return;

    var carrier = form.querySelector('[data-tracking-carrier]');
    var code = form.querySelector('[data-tracking-code]');
    var error = form.querySelector('[data-tracking-error]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var value = (code.value || '').trim();
      var template = carrier.value || '';

      if (!value || template.indexOf('{code}') === -1) {
        if (error) error.hidden = false;
        return;
      }

      if (error) error.hidden = true;
      window.open(template.replace('{code}', encodeURIComponent(value)), '_blank', 'noopener');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-page"]) return;
  try {
    
  /* İçindekiler: kaydırırken okunan maddeyi işaretler.

     Neden IntersectionObserver'ın "isIntersecting"i tek başına yetmez:
     ekranda aynı anda birkaç madde olabiliyor. Bu yüzden ekranda olanlar
     arasından EN ÜSTTEKİ seçiliyor — okunan madde odur. */
  (function () {
    var root = document.querySelector('[data-policy]');
    if (!root) return;

    var links = root.querySelectorAll('[data-toc-link]');
    var clauses = root.querySelectorAll('[data-clause]');
    if (!links.length || !clauses.length || !('IntersectionObserver' in window)) return;

    var visible = new Set();

    function paint() {
      var top = null;
      clauses.forEach(function (clause) {
        if (!visible.has(clause.dataset.clause)) return;
        if (top === null) top = clause.dataset.clause;
      });
      if (top === null) return;

      links.forEach(function (link) {
        link.classList.toggle('is-current', link.dataset.tocLink === top);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var id = entry.target.dataset.clause;
          if (entry.isIntersecting) {
            visible.add(id);
          } else {
            visible.delete(id);
          }
        });
        paint();
      },
      /* Üstteki yapışkan başlığın altında kalan kısım "görünür" sayılmaz. */
      { rootMargin: '-110px 0px -55% 0px', threshold: 0 }
    );

    clauses.forEach(function (clause) { observer.observe(clause); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vslider]').forEach(function (root) {
      var track = root.querySelector('[data-vslider-track]');
      var videos = root.querySelectorAll('[data-vslider-video]');
      var prev = root.querySelector('[data-vslider-prev]');
      var next = root.querySelector('[data-vslider-next]');
      var forced = document.documentElement.hasAttribute('data-force-motion');
      var reduced = !forced && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Görünürken oynat, çıkınca durdur. */
      if (!reduced && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting) {
                if (v.preload === 'none') v.preload = 'auto';
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                v.pause();
              }
            });
          },
          { threshold: 0.35 }
        );
        videos.forEach(function (v) { io.observe(v); });
      }

      function step(dir) {
        var item = track.querySelector('.vslider__item');
        if (!item) return;
        var w = item.getBoundingClientRect().width + 20;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      /* Otomatik ilerleme. Kullanıcı elle kaydırınca ya da fare üstündeyken
         durur; 6 sn sonra kendiliğinden devam eder (kalıcı kilit YOK — bu,
         yorum rayında kilitlenmeye yol açan hataydı). */
      if (!reduced) {
        var paused = false;
        var resumeTimer = null;

        function holdFor(ms) {
          paused = true;
          clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function () { paused = false; }, ms);
        }

        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
        track.addEventListener('pointerdown', function () { holdFor(6000); }, { passive: true });
        track.addEventListener('wheel', function () { holdFor(6000); }, { passive: true });

        setInterval(function () {
          if (paused || document.hidden) return;
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
          if (atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            step(1);
          }
        }, 4000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
